export const SET_CHANGED_PERMIT_FILTER = 'SET_CHANGED_PERMIT_FILTER';
export const SET_CHANGE_VISIBLE_PERMIT_FILTER =
  'SET_CHANGE_VISIBLE_PERMIT_FILTER';
export const RESET_PERMIT_FILTER = 'RESET_PERMIT_FILTER';
export const SET_STREET_ID_PERMIT_FILTER = ' SET_STREET_ID_PERMIT_FILTER';
export const SET_HOUSE_ID_PERMIT_FILTER = ' SET_HOUSE_ID_PERMIT_FILTER';
export const SET_FLAT_ID_PERMIT_FILTER = ' SET_FLAT_ID_PERMIT_FILTER';
export const SET_DATE_RANGE_PERMIT_FILTER = ' SET_DATE_RANGE_PERMIT_FILTER';
export const SET_DATE_RANGE_FIELD_PERMIT_FILTER =
  'SET_DATE_RANGE_FIELD_PERMIT_FILTER';
export const SET_TYPE_ID_PERMIT_FILTER = ' SET_TYPE_ID_PERMIT_FILTER';
export const SET_STATUS_ID_PERMIT_FILTER = 'SET_STATUS_ID_PERMIT_FILTER';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
